/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hero_TitleInputs */

const en_contact_hero_title = /** @type {(inputs: Contact_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to the people behind the app`)
};

const pl_contact_hero_title = /** @type {(inputs: Contact_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porozmawiaj z ludźmi, którzy tworzą aplikację`)
};

/**
* | output |
* | --- |
* | "Talk to the people behind the app" |
*
* @param {Contact_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hero_title = /** @type {((inputs?: Contact_Hero_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hero_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_hero_title(inputs)
	return en_contact_hero_title(inputs)
});